// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__1pf_J","description":"PatientConsentPreview_description__1b3iZ"};